import { PauseIcon } from "./icons/PauseIcon";

const PauseButton = (props) => {
  return (
    <div
      style={{
        position: "relative",
        width: "55px",
        height: "56px",
        border: "5px solid black",
        borderRadius: "10px",
        marginRight: "5px",
        cursor: "pointer",
      }}
      {...props}
    >
      <PauseIcon />
    </div>
  );
};

export { PauseButton };
